import React from 'react';

export interface DataCellProps {
  children: React.ReactNode;
  variant?: 'primary' | 'muted' | 'numeric' | 'date' | 'actions';
  className?: string;
}

const DataCell: React.FC<DataCellProps> = ({
  children,
  variant = 'muted',
  className = '',
}) => {
  const variantClasses: Record<string, string> = {
    primary: 'text-sm font-bold tracking-tight text-monday-text',
    muted: 'text-sm font-medium text-monday-text-muted',
    numeric: 'text-sm font-semibold tabular-nums text-monday-text',
    date: 'text-sm font-medium tabular-nums text-monday-text',
    actions: 'text-right text-sm font-medium text-monday-text-muted',
  };

  return (
    <span className={`${variantClasses[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default DataCell;
